/* eslint-disable */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../../../../config';
import './bookingDetailsFeedback.scss';

const propTypes = {
    job: PropTypes.object,
    onFeedbackPostStart: PropTypes.func.isRequired,
    onFeedbackPostEnd: PropTypes.func.isRequired,
    onFeedbackPostSuccess: PropTypes.func.isRequired,
};

const rules = [
    {
        clientScore: 5,
        questionText: 'What made them stand out?',
        tags: [
            { value: 'communication_skills', label: 'Great communication' },
            { value: 'speed', label: 'Fast worker' },
            { value: 'attitude', label: 'Good attitude' },
            { value: 'skills', label: 'Highly skilled' },
            { value: 'time_management', label: 'Punctuality' },
        ],
        starsByCountOfTappedTags: {
            1: 5,
            2: 5,
            3: 5,
            4: 5,
            5: 5,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 4,
        questionText: 'How could they reach 5 stars?',
        tags: [
            { value: 'communication_skills', label: 'Communication' },
            { value: 'speed', label: 'Work faster' },
            { value: 'attitude', label: 'Better attitude' },
            { value: 'skills', label: 'Improve skills' },
            { value: 'time_management', label: 'Be more punctual' },
        ],
        starsByCountOfTappedTags: {
            1: 2,
            2: 3,
            3: 3,
            4: 4,
            5: 4,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 3,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 2,
            3: 2,
            4: 3,
            5: 3,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 2,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 1,
            3: 1,
            4: 2,
            5: 2,
        },
        isJobOfferTag: false,
    },

    {
        clientScore: 1,
        questionText: 'Sorry to hear! What went wrong?',
        tags: [
            { value: 'communication_skills', label: 'Poor communication' },
            { value: 'speed', label: 'Slow worker' },
            { value: 'attitude', label: 'Poor attitude' },
            { value: 'skills', label: 'Lack of skills' },
            { value: 'time_management', label: 'Late or no show' },
        ],
        starsByCountOfTappedTags: {
            1: 1,
            2: 1,
            3: 1,
            4: 1,
            5: 1,
        },
        isJobOfferTag: false,
    },
];

class BookingDetailsFeedback extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rating: 0,
            tagsSelected: [],
            isJobOffer: false,
            isPostingFeedback: false,
            comment: '',
        };

        this.handleStarClick = this.handleStarClick.bind(this);
        this.onTagClick = this.onTagClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.job.id !== nextProps.job.id) {
            this.setState({
                rating: 0,
                tagsSelected: [],
                isJobOffer: false,
                comment: '',
            });
        }
    }

    postFeedback() {
        const clientScore = this.state.rating;
        const {
            job,
            onFeedbackPostStart,
            onFeedbackPostEnd,
            onFeedbackPostSuccess,
        } = this.props;
        if (job) {
            const jobId = job.id;
            const freelancerId = job.booking.freelancer_detail.id;

            const data = {
                freelancer: freelancerId,
                score: clientScore,
                job_offer: this.state.isJobOffer,
                comment: this.state.comment,
            };

            const { tagsSelected } = this.state;
            if (tagsSelected.length > 0) {
                const rule = rules.find(
                    item => item.clientScore === clientScore,
                );
                const tagScore =
                    rule.starsByCountOfTappedTags[tagsSelected.length];
                tagsSelected.map(tag => {
                    data[tag] = tagScore;
                });
            }

            this.setState({
                isPostingFeedback: true,
            });

            onFeedbackPostStart();

            axios({
                method: 'POST',
                url: `${ROOT_URL_V2}jobs/${jobId}/feedbacks/`,
                data,
                headers: {
                    'X-CSRFToken': getCSRFToken(),
                },
            })
                .then(() => {
                    this.setState({
                        isPostingFeedback: false,
                    });
                    onFeedbackPostEnd();
                    onFeedbackPostSuccess();
                })
                .catch(error => {
                    onFeedbackPostEnd();
                    this.setState({
                        isPostingFeedback: false,
                    });
                    throw error;
                });
        }
    }

    handleStarClick(index) {
        this.setState({
            rating: index,
            tagsSelected: [],
            isJobOffer: false,
        });
    }

    renderStars() {
        const { rating } = this.state;
        const stars = [];
        for (let i = 0; i <= 4; i++) {
            const classNames = [
                'icon icon-star-full',
                i < rating ? 'active' : '',
            ];
            const star = (
                <i
                    key={i}
                    className={classNames.join(' ')}
                    onClick={() => {
                        this.handleStarClick(i + 1);
                    }}
                />
            );
            stars.push(star);
        }
        return <div className="booking-details-feedback__stars">{stars}</div>;
    }

    renderTags() {
        const { rating, tagsSelected } = this.state;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);
            const { tags } = rule;

            return tags.map((tag, index) => {
                const isSelected = tagsSelected.indexOf(tag.value) >= 0;
                return (
                    <div
                        key={index}
                        className={[
                            'booking-details-feedback__tag',
                            isSelected ? 'active' : '',
                        ].join(' ')}
                        onClick={() => {
                            this.onTagClick(tag.value);
                        }}
                    >
                        {tag.label}
                    </div>
                );
            });
        }

        return null;
    }

    renderQuestion() {
        const { rating } = this.state;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);
            const { questionText } = rule;

            return (
                <div className="booking-details-feedback__question">
                    {questionText}
                </div>
            );
        }

        return null;
    }

    renderJobOfferTag() {
        const { rating, isJobOffer } = this.state;
        const { job } = this.props;
        const freelancer = job.booking.freelancer_detail;
        if (rating > 0) {
            const rule = rules.find(item => item.clientScore === rating);

            if (rule.isJobOfferTag) {
                return (
                    <div
                        className={[
                            'booking-details-feedback__tag separated checkbox',
                            isJobOffer ? 'active' : '',
                        ].join(' ')}
                        onClick={() => {
                            this.setState({ isJobOffer: !isJobOffer });
                        }}
                    >
                        I would like to hire {freelancer.first_name} full time
                    </div>
                );
            }

            return null;
        }

        return null;
    }

    onTagClick(value) {
        const { tagsSelected } = this.state;
        const index = tagsSelected.indexOf(value);
        if (index >= 0) {
            tagsSelected.splice(index, 1);
        } else {
            tagsSelected.push(value);
        }
        this.setState({
            tagsSelected,
        });
    }

    renderExistingFeedbackStars() {
        const { client_feedback } = this.props.job.booking;
        if (client_feedback) {
            const stars = [];
            const rating = client_feedback.score;
            for (let i = 0; i <= 4; i++) {
                const classNames = [
                    'icon icon-star-full',
                    i < rating ? 'active' : '',
                ];
                const star = <i key={i} className={classNames.join(' ')} />;
                stars.push(star);
            }
            return (
                <div className="booking-details-feedback__static-stars">
                    {stars}
                </div>
            );
        }
    }

    renderAdditionalComment() {
        const { rating, comment } = this.state;
        if (rating > 0) {
            return (
                <textarea
                    className="booking-details-feedback__comment"
                    onChange={e => this.setState({ comment: e.target.value })}
                    placeholder="More details"
                    value={comment}
                />
            );
        }

        return null;
    }

    render() {
        const { rating, isPostingFeedback } = this.state;
        const client_feedback = this.props.job
            ? this.props.job.booking.client_feedback
            : null;

        if (client_feedback) {
            return (
                <div className="booking-details-feedback">
                    {this.renderExistingFeedbackStars()}
                </div>
            );
        }

        return (
            <div className="booking-details-feedback">
                {this.renderStars()}
                {this.renderQuestion()}
                <div className="booking-details-feedback__tags">
                    {this.renderTags()}
                </div>
                {this.renderAdditionalComment()}
                {this.renderJobOfferTag()}
                <button
                    className="booking-details-feedback__save-btn btn--round-big"
                    onClick={this.postFeedback.bind(this)}
                    disabled={isPostingFeedback || rating < 1}
                >
                    {isPostingFeedback ? 'SUBMITTING...' : 'SUBMIT'}
                </button>
            </div>
        );
    }
}

BookingDetailsFeedback.propTypes = propTypes;

export default withRouter(BookingDetailsFeedback);
